import { Link } from "react-router";
import { useAuthStore } from "../../stores/auth.store";

export function LandingPage() {
  const user = useAuthStore((s) => s.user);

  return (
    <div className="flex flex-col items-center gap-8 py-16 text-center">
      <h1 className="text-4xl font-bold tracking-tight sm:text-5xl">
        Book with the best
      </h1>
      <p className="max-w-md text-lg text-gray-600">
        Find and book barbers, hair stylists, and nail techs near you.
      </p>
      <div className="flex gap-3">
        <Link
          to="/explore"
          className="rounded-lg bg-gray-900 px-6 py-3 font-medium text-white hover:bg-gray-800"
        >
          Explore
        </Link>
        {!user && (
          <Link
            to="/login"
            className="rounded-lg border border-gray-300 px-6 py-3 font-medium text-gray-700 hover:bg-gray-50"
          >
            Log in
          </Link>
        )}
      </div>
      <Link
        to="/bookings/lookup"
        className="text-sm font-medium text-gray-500 hover:text-gray-900"
      >
        Look up a booking
      </Link>
    </div>
  );
}
